import { all, call, put, takeLatest } from "redux-saga/effects";
import { v4 as uuidv4 } from 'uuid';
import { AxiosCall } from "../../../utils/axios";
import * as actions from "./actions";

function* fetchCheckout() {
    try {
        const result = yield call(AxiosCall, `/shop/get_customer_invoices/`);
        if (result.data.response === "UNHANDLED_EXCEPTION") {
            yield put(actions.fetchCheckoutSuccess([]));
        }
        else {
            yield put(actions.fetchCheckoutSuccess(result.data.response));
        }
    } catch (e) {
        yield put(actions.fetchCheckoutFailure(e.message || 'Error al obtener el checkout'));
    }
}


export function* getCheckoutConfirmation() {
    try {
        const result = yield call(AxiosCall, `/shop/get_checkout_confirmation/`);
        if (result.data.response === "UNHANDLED_EXCEPTION") {
            yield put(actions.getCheckoutConfirmation(null));
        }
        else {
            const response = result.data.response;
            // Reset SESSION ID if purchase was completed
            if (response.completed === true) {
                const sessionId = uuidv4();
                localStorage.setItem('sessionId', sessionId);
            }
            yield put(actions.getCheckoutConfirmationSuccess(result.data.response));
        }
    } catch (e) {
        yield put(actions.getCheckoutConfirmationFailure(e.message || 'Error al obtener el checkout'));
    }
}



function* fetchStripeCheckoutUrl() {
    try {
        const result = yield call(AxiosCall, `/shop/get_stripe_checkout_url/`);
        if (result.data.response === "UNHANDLED_EXCEPTION") {
            yield put(actions.fetchCheckoutSuccess([]));
        }
        else {
            yield put(actions.getStripeCheckoutUrlSuccess(result.data.response));
        }
    } catch (e) {
        yield put(actions.fetchCheckoutFailure(e.message || 'Error al obtener el checkout'));
    }
}



export default function* rootSaga() {
    yield all([
        // watchers
        takeLatest(actions.FETCH_CHECKOUT.REQUEST, fetchCheckout),
        takeLatest(actions.GET_STRIPE_CHECKOUT_URL.REQUEST, fetchStripeCheckoutUrl),
        takeLatest(actions.GET_CHECKOUT_CONFIRMATION.REQUEST, getCheckoutConfirmation),

    ])
}